/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant
*/

import dashboard from './dashboard'
import administracion from './administracion'
import mantenimiento from './mantenimiento'
import movimientos from './movimientos'
import checador from './checador'

// Array of sections
export default [...dashboard, ...administracion, ...mantenimiento, ...movimientos, ...checador]
